import React from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import { useGeneral } from "~/hooks/use-general";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  useForm,
} from "../ui/form";
import { ModalInput } from "../ui/modal-input";
import { MultiSelect } from "../ui/multi-select";

export default function ProductPriceForm({
  productPrices,
  onClose,
}: {
  productPrices: { priceId: string; value: number }[];
  onClose: ({ priceId, value }: { priceId: string; value: number }) => void;
}) {
  const { t } = useTranslation("common");
  const { prices } = useGeneral();

  const form = useForm({
    schema: z.object({
      priceId: z.string(),
      value: z.number(),
    }),
    defaultValues: {
      priceId: prices.at(0)?.id,
      value: 0,
    },
  });

  const handleSubmit = form.handleSubmit((data) => {
    onClose(data);
  });

  return (
    <Form {...form}>
      <form
        id="product-price-form"
        onSubmit={handleSubmit}
        className="grid grid-cols-2 gap-2"
      >
        <FormField
          control={form.control}
          name="priceId"
          render={({ field }) => (
            <FormItem className="col-span-full">
              <FormLabel>{t("price")}</FormLabel>
              <FormControl>
                <MultiSelect
                  maxSelect={1}
                  placeholder="Select price..."
                  onValueChange={(value) => {
                    field.onChange(value[0]);
                  }}
                  options={prices.sort().map((price) => ({
                    label: price.name,
                    value: price.id,
                  }))}
                  defaultValue={field.value ? [field.value] : []}
                  value={field.value}
                />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="value"
          render={({ field }) => (
            <FormItem className="col-span-full">
              <FormLabel>{t("price")}</FormLabel>
              <FormControl>
                <ModalInput
                  label="Enter value for price"
                  type="decimal"
                  value={field.value}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
}
